export default __webpack_public_path__ + "assets/images/f2e11b9ab4fd1df0258602126693115c.png";